// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/core/svc_adminka.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { AdminOrganizationListStreamReq, AdminOrganizationListStreamResp, AdminUserInfoStreamReq, AdminUserInfoStreamResp, AdminUserListStreamReq, AdminUserListStreamResp, MarkOrganizationAsDistributorReq, MarkOrganizationAsDistributorResp, MarkOrganizationAsDSOReq, MarkOrganizationAsDSOResp, SetOrganizationDistributorReq, SetOrganizationDistributorResp, SetOrganizationDSOParentReq, SetOrganizationDSOParentResp, SetOrganizationFeatureFlagReq, SetOrganizationFeatureFlagResp, SystemLoad_GetReq, SystemLoad_GetResp, SystemLoad_SetSettingsReq, SystemLoad_SetSettingsResp, UnmarkOrganizationAsDistributorReq, UnmarkOrganizationAsDistributorResp, UnmarkOrganizationAsDSOReq, UnmarkOrganizationAsDSOResp } from "./svc_adminka_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.core.AdminService
 */
export const AdminService = {
  typeName: "com.diagnocat.core.AdminService",
  methods: {
    /**
     * Default sort by Created.At
     * Permission: `AdminPermissions.BasicAccess`
     *
     * @generated from rpc com.diagnocat.core.AdminService.AdminUserListStream
     */
    adminUserListStream: {
      name: "AdminUserListStream",
      I: AdminUserListStreamReq,
      O: AdminUserListStreamResp,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Default sort by Name
     * Permission: `AdminPermissions.BasicAccess` sees all organizations; a distributor user sees only that distributor's clients
     *
     * @generated from rpc com.diagnocat.core.AdminService.AdminOrganizationListStream
     */
    adminOrganizationListStream: {
      name: "AdminOrganizationListStream",
      I: AdminOrganizationListStreamReq,
      O: AdminOrganizationListStreamResp,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Permission: `AdminPermissions.BasicAccess`
     *
     * @generated from rpc com.diagnocat.core.AdminService.AdminUserInfoStream
     */
    adminUserInfoStream: {
      name: "AdminUserInfoStream",
      I: AdminUserInfoStreamReq,
      O: AdminUserInfoStreamResp,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Allowed when the feature flag is not read-only for the actor (see `FeatureFlag.IsReadOnly`); no role check beyond that
     *
     * @generated from rpc com.diagnocat.core.AdminService.SetOrganizationFeatureFlag
     */
    setOrganizationFeatureFlag: {
      name: "SetOrganizationFeatureFlag",
      I: SetOrganizationFeatureFlagReq,
      O: SetOrganizationFeatureFlagResp,
      kind: MethodKind.Unary,
    },
    /**
     * Marks organization as a distributor with the given name
     * Permission: `User.CanManageDistributors`
     *
     * @generated from rpc com.diagnocat.core.AdminService.MarkOrganizationAsDistributor
     */
    markOrganizationAsDistributor: {
      name: "MarkOrganizationAsDistributor",
      I: MarkOrganizationAsDistributorReq,
      O: MarkOrganizationAsDistributorResp,
      kind: MethodKind.Unary,
    },
    /**
     * Removes distributor status from an organization
     * Permission: `User.CanManageDistributors`
     *
     * @generated from rpc com.diagnocat.core.AdminService.UnmarkOrganizationAsDistributor
     */
    unmarkOrganizationAsDistributor: {
      name: "UnmarkOrganizationAsDistributor",
      I: UnmarkOrganizationAsDistributorReq,
      O: UnmarkOrganizationAsDistributorResp,
      kind: MethodKind.Unary,
    },
    /**
     * Sets the distributor for an existing organization
     * Permission: `User.CanManageDistributors`
     *
     * @generated from rpc com.diagnocat.core.AdminService.SetOrganizationDistributor
     */
    setOrganizationDistributor: {
      name: "SetOrganizationDistributor",
      I: SetOrganizationDistributorReq,
      O: SetOrganizationDistributorResp,
      kind: MethodKind.Unary,
    },
    /**
     * Marks organization as DSO
     * Permission: `User.CanManageDSO`
     *
     * @generated from rpc com.diagnocat.core.AdminService.MarkOrganizationAsDSO
     */
    markOrganizationAsDSO: {
      name: "MarkOrganizationAsDSO",
      I: MarkOrganizationAsDSOReq,
      O: MarkOrganizationAsDSOResp,
      kind: MethodKind.Unary,
    },
    /**
     * Removes dso status from an organization
     * Permission: `User.CanManageDSO`
     *
     * @generated from rpc com.diagnocat.core.AdminService.UnmarkOrganizationAsDSO
     */
    unmarkOrganizationAsDSO: {
      name: "UnmarkOrganizationAsDSO",
      I: UnmarkOrganizationAsDSOReq,
      O: UnmarkOrganizationAsDSOResp,
      kind: MethodKind.Unary,
    },
    /**
     * Sets organization parent organization
     * Permission: `User.CanManageDSO`
     *
     * @generated from rpc com.diagnocat.core.AdminService.SetOrganizationDSOParent
     */
    setOrganizationDSOParent: {
      name: "SetOrganizationDSOParent",
      I: SetOrganizationDSOParentReq,
      O: SetOrganizationDSOParentResp,
      kind: MethodKind.Unary,
    },
    /**
     * Returns the current system load state per source: raw metric, computed/effective levels, manual override, thresholds and serve toggles
     * Permission: `AdminPermissions.SystemLoad_CanView`
     *
     * @generated from rpc com.diagnocat.core.AdminService.SystemLoad_Get
     */
    systemLoad_Get: {
      name: "SystemLoad_Get",
      I: SystemLoad_GetReq,
      O: SystemLoad_GetResp,
      kind: MethodKind.Unary,
    },
    /**
     * Sets manual load level overrides and level thresholds
     * Permission: `AdminPermissions.SystemLoad_CanChange`
     *
     * Errors:
     *   - type: InvalidArgumentValueError, Argument: Thresholds - (if any thresholds violate 0 <= Medium <= High)
     *
     * @generated from rpc com.diagnocat.core.AdminService.SystemLoad_SetSettings
     */
    systemLoad_SetSettings: {
      name: "SystemLoad_SetSettings",
      I: SystemLoad_SetSettingsReq,
      O: SystemLoad_SetSettingsResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

